// Normalises a list-style API response into a plain array.
//
// The backend has returned list payloads in three shapes across versions, and
// v5 paginates some endpoints that used to return a bare array:
//
//   [ ... ]                      -> bare array (older shape)
//   { data: [ ... ] }            -> paginated wrapper (get-tip-list, get-category-list, ...)
//   { data: { value: [ ... ] } } -> get-all-programs currently double-wraps its rows
//
// Returning [] for anything unexpected keeps a list screen rendering empty
// instead of throwing "x.map is not a function".
export function toArray(responseData) {
  if (Array.isArray(responseData)) return responseData;
  if (responseData && Array.isArray(responseData.data)) return responseData.data;
  if (
    responseData &&
    responseData.data &&
    Array.isArray(responseData.data.value)
  ) {
    return responseData.data.value;
  }
  return [];
}
